// import * as React from "react";
// import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import Modal from "@mui/material/Modal";
// import moment from "moment"; // Import moment for date formatting
// import { Button } from "@mui/material";
// import APICall from "../../Utility/APICall";
// import { paths } from "../../Utility/Constants";
// import { useState } from "react";
// import { useAuth } from "../../Utility/AuthProvider";
// import { useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
// };

// export default function CongratsModal({
//   open,
//   onClose,
//   agreementData,
//   tenantData,
//   unitData,
//   addAgreement,
// }) {
//   const [viewDetailsLoading, setViewDetailsLoading] = useState(false);
//   const [viewDetailsError, setViewDetailsError] = useState(null);
//   const { jwt } = useAuth(); // Access JWT if needed
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [isUpdate, setIsUpdate] = useState(false); // Define isUpdate
//   const [originalAgreement, setOriginalAgreement] = useState(null); // Define originalAgreement

//   console.log("Agreement Data entered 💋 -", agreementData);
//   console.log("Tenant Data entered 🇮🇳 -", tenantData);
//   console.log("Unit Data for Agreement 💎 -", unitData);

//   console.log("🦿😈🧢🔎 add agreement res ---", addAgreement);

//   console.log(
//     "Tenant Data on CongratsModal via AgreementOverview props 😀 -",
//     tenantData
//   );

//   const rent =
//     addAgreement?.response?.rent && addAgreement.response.rent.length > 0
//       ? addAgreement.response.rent[0].rent
//       : "N/A";

//   const created =
//     addAgreement?.response?.created && addAgreement.response.created;

//   const formattedCreatedDate = created
//     ? moment(created).format("MMM DD, YYYY at hh:mm A")
//     : "N/A";

//   const handleViewDetails = useCallback(() => {
//     console.log("🎯 Agreement Response:", addAgreement.response);
//     const actualUnitId = addAgreement.response.unit_id; // e.g., "998250787781991434"
//     const unit_name = addAgreement.response.unit_name;
//     if (!actualUnitId) {
//       console.error("CRITICAL: addAgreement.response.unit_id is missing!");
//       return;
//     }

//     console.log("ADD AGGREEMENT:", addAgreement);

//     console.log(" UNIT ID for Navigation on CONGRATS PAGE:", actualUnitId);
//     console.log("ENTITY ID  on CONGRATS AGE:", addAgreement.response.unit_id);
//     console.log(
//       "ENTITY ID  on CONGRATS AGE 22222:",
//       addAgreement.response.unitId
//     );

//     navigate(`/dashboard/my-properties/${actualUnitId}`, {
//       state: {
//         entity_id: addAgreement.response.unit_id,
//         needsUpdate: true,
//         updateData: {
//           agreement_id: addAgreement.response.entity_id,
//           rent: addAgreement.response.rent?.[0]?.rent,
//           // unit_id: addAgreement.response.unit_id,
//           unit_id: actualUnitId,
//           occupancy_status: "rented",
//           tenant_name: tenantData[0]
//             ? `${tenantData[0].first_name} ${tenantData[0].last_name}`
//             : "N/A",
//           isUpdate,
//           building_id: addAgreement.response.building_id,
//           tenantCount: tenantData.length,
//           originalAgreementTenantCount:
//             originalAgreement?.tenant_id.length || 0,
//         },
//       },
//     });
//   }, [addAgreement, tenantData, isUpdate, originalAgreement, navigate]);

//   const getPrimaryTenant = (tenantIds) => {
//     // Assuming tenantIds is an array of tenant IDs. You might need to fetch tenant details separately.
//     if (!tenantIds || tenantIds.length === 0) return "N/A";

//     // Placeholder: Replace with actual logic to fetch tenant name based on ID
//     return "Tenant " + tenantIds[0];
//   };

//   const getRentAmount = (rentArray) => {
//     if (!rentArray || rentArray.length === 0) return "N/A";
//     return rentArray[0].rent; // Assuming rent is in the first element.
//   };

//   return (
//     <Modal
//       open={open}
//       onClose={onClose}
//       aria-labelledby="modal-modal-title"
//       aria-describedby="modal-modal-description"
//     >
//       <Box sx={style}>
//         <Typography id="modal-modal-title" variant="h6" component="h2">
//           Congratulations, Agreement Added Successfully!
//         </Typography>
//         <Typography>Agreement Details</Typography>
//         <Typography id="modal-modal-description" sx={{ mt: 2 }}>
//           Rent Amount: {rent}
//           {/* Optional chaining */}
//         </Typography>
//         <Typography sx={{ mt: 2 }}>
//           Primary Tenant:{" "}
//           {tenantData && tenantData.length > 0
//             ? `${tenantData[0].first_name} ${tenantData[0].last_name}`
//             : "N/A"}{" "}
//           {/* Conditional rendering */}
//         </Typography>
//         <Typography sx={{ mt: 2 }}>
//           Date Created: {formattedCreatedDate || "N/A"}
//         </Typography>{" "}
//         {/* Conditional rendering */}
//         {/* ... other JSX */}
//         <Button onClick={handleViewDetails} variant="contained">
//           View Details
//         </Button>
//       </Box>
//     </Modal>
//   );
// }

// import React from "react";
// import { FaCheckCircle } from "react-icons/fa";
// import moment from "moment";
// import CustomButton from "../Buttons/CustomButton";

// const CongratsModal = ({
//   open,
//   onClose,
//   agreementData,
//   tenantData,
//   unitData,
//   addAgreement,
//   isUpdate = false,
// }) => {
//   if (!open) return null;

//   // Extract data safely
//   const rent =
//     addAgreement?.response?.rent?.[0]?.rent ||
//     addAgreement?.response?.rent ||
//     agreementData?.monthlyRent ||
//     "N/A";

//   const primaryTenant =
//     tenantData && tenantData.length > 0
//       ? `${tenantData[0].first_name} ${tenantData[0].last_name}`
//       : "N/A";

//   const created = addAgreement?.response?.created || new Date();
//   const formattedCreatedDate = moment(created).format(
//     "MMM DD, YYYY [at] hh:mm A"
//   );

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
//       {/* Modal Content */}
//       <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 overflow-hidden">
//         {/* Success Background */}
//         <div className="bg-gradient-to-r from-green-400 to-green-500 px-6 py-8 text-center">
//           <div className="flex justify-center mb-4">
//             <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center">
//               <FaCheckCircle className="text-green-500 text-2xl" />
//             </div>
//           </div>
//           <h2 className="text-2xl font-bold text-white mb-2">
//             Congratulations!
//           </h2>
//           <p className="text-green-100">
//             Your agreement was {isUpdate ? "updated" : "created"} successfully.
//           </p>
//         </div>

//         {/* Agreement Details */}
//         <div className="p-6">
//           <h3 className="text-lg font-semibold text-gray-900 mb-4">
//             Agreement Details
//           </h3>

//           <div className="space-y-3">
//             <div className="flex justify-between items-center py-2 border-b border-gray-100">
//               <span className="text-gray-600">Rent Amount</span>
//               <span className="font-semibold text-gray-900">
//                 ₹{typeof rent === "number" ? rent.toLocaleString() : rent}
//               </span>
//             </div>

//             <div className="flex justify-between items-center py-2 border-b border-gray-100">
//               <span className="text-gray-600">Primary Tenant</span>
//               <span className="font-semibold text-gray-900">
//                 {primaryTenant}
//               </span>
//             </div>

//             <div className="flex justify-between items-center py-2">
//               <span className="text-gray-600">
//                 Date {isUpdate ? "Updated" : "Created"}
//               </span>
//               <span className="font-semibold text-gray-900 text-sm">
//                 {formattedCreatedDate}
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Action Button */}
//         <div className="px-6 pb-6">
//           <CustomButton
//             tailwindClasses="w-full bg-blue-500 text-white py-3 text-lg font-medium hover:bg-blue-600 transition-colors"
//             label="View Details"
//             onClick={onClose}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CongratsModal;

import React from "react";
import { FaCheckCircle, FaEdit } from "react-icons/fa";
import moment from "moment";
import CustomButton from "../Buttons/CustomButton";

const CongratsModal = ({
  open,
  onClose,
  agreementData,
  tenantData,
  unitData,
  addAgreement,
  isUpdate = false,
  isModify = false, // NEW: Distinguish between update and modify
  originalData = null, // NEW: Original agreement data for comparison
  modifiedData = null, // NEW: Modified agreement data
}) => {
  if (!open) return null;

  // Extract data safely
  const rent =
    addAgreement?.response?.rent?.[0]?.rent ||
    addAgreement?.response?.rent ||
    agreementData?.monthlyRent ||
    modifiedData?.rent ||
    "N/A";

  const primaryTenant =
    tenantData && tenantData.length > 0
      ? `${tenantData[0].first_name} ${tenantData[0].last_name}`
      : "N/A";

  const created = addAgreement?.response?.created || new Date();
  const formattedCreatedDate = moment(created).format(
    "MMM DD, YYYY [at] hh:mm A"
  );

  // NEW: Get changes for modify flow
  const getChanges = () => {
    if (!isModify || !originalData || !modifiedData) return [];

    const changes = [];
    const fieldsToCheck = {
      rent: "Monthly Rent",
      security_deposit: "Security Deposit",
      maintenance: "Maintenance",
      due_date: "Due Date",
      tenure: "Tenure",
      staying_from: "Staying From",
      vacating_on: "Vacating On",
    };

    Object.entries(fieldsToCheck).forEach(([key, label]) => {
      const oldValue = originalData[key];
      const newValue = modifiedData[key];

      if (
        oldValue !== newValue &&
        newValue !== undefined &&
        newValue !== null
      ) {
        changes.push({
          field: label,
          oldValue: formatValue(key, oldValue),
          newValue: formatValue(key, newValue),
        });
      }
    });

    // Check tenant changes
    const originalTenantCount = originalData.tenant_id?.length || 0;
    const newTenantCount = tenantData?.length || 0;

    if (originalTenantCount !== newTenantCount) {
      changes.push({
        field: "Number of Tenants",
        oldValue: originalTenantCount,
        newValue: newTenantCount,
      });
    }

    return changes;
  };

  // NEW: Format values for display
  const formatValue = (key, value) => {
    if (!value) return "N/A";

    switch (key) {
      case "rent":
      case "security_deposit":
      case "maintenance":
        return `₹${typeof value === "number" ? value.toLocaleString() : value}`;
      case "due_date":
        return `${value} of every month`;
      case "staying_from":
      case "vacating_on":
        return moment(value).format("MMM DD, YYYY");
      default:
        return value;
    }
  };

  const changes = getChanges();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
      {/* Modal Content */}
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 overflow-hidden max-h-[90vh] overflow-y-auto">
        {/* Success Background */}
        <div
          className={`${isModify ? "bg-gradient-to-r from-orange-400 to-orange-500" : "bg-gradient-to-r from-green-400 to-green-500"} px-6 py-8 text-center`}
        >
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center">
              {isModify ? (
                <FaEdit className="text-orange-500 text-2xl" />
              ) : (
                <FaCheckCircle className="text-green-500 text-2xl" />
              )}
            </div>
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">
            {isModify ? "Agreement Modified!" : "Congratulations!"}
          </h2>
          <p className={`${isModify ? "text-orange-100" : "text-green-100"}`}>
            Your agreement was{" "}
            {isModify ? "modified" : isUpdate ? "updated" : "created"}{" "}
            successfully.
          </p>
        </div>

        {/* Agreement Details */}
        <div className="p-6">
          {isModify && changes.length > 0 ? (
            // Show changes for modify flow
            <>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Changes Made
              </h3>
              <div className="space-y-4">
                {changes.map((change, index) => (
                  <div key={index} className="bg-gray-50 rounded-lg p-4">
                    <div className="font-semibold text-gray-700 mb-2">
                      {change.field}
                    </div>
                    <div className="flex items-center space-x-2 text-sm">
                      <span className="bg-red-100 text-red-800 px-2 py-1 rounded line-through">
                        {change.oldValue}
                      </span>
                      <span className="text-gray-400">→</span>
                      <span className="bg-green-100 text-green-800 px-2 py-1 rounded font-semibold">
                        {change.newValue}
                      </span>
                    </div>
                  </div>
                ))}
              </div>

              {/* Summary section */}
              <div className="mt-6 pt-4 border-t border-gray-200">
                <h4 className="font-semibold text-gray-700 mb-3">
                  Current Details
                </h4>
                <div className="space-y-2">
                  <div className="flex justify-between items-center py-1">
                    <span className="text-gray-600">Current Rent</span>
                    <span className="font-semibold text-gray-900">
                      ₹{typeof rent === "number" ? rent.toLocaleString() : rent}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-1">
                    <span className="text-gray-600">Primary Tenant</span>
                    <span className="font-semibold text-gray-900">
                      {primaryTenant}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-1">
                    <span className="text-gray-600">Total Tenants</span>
                    <span className="font-semibold text-gray-900">
                      {tenantData?.length || 0}
                    </span>
                  </div>
                </div>
              </div>
            </>
          ) : (
            // Original layout for create/update flow
            <>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Agreement Details
              </h3>

              <div className="space-y-3">
                <div className="flex justify-between items-center py-2 border-b border-gray-100">
                  <span className="text-gray-600">Rent Amount</span>
                  <span className="font-semibold text-gray-900">
                    ₹{typeof rent === "number" ? rent.toLocaleString() : rent}
                  </span>
                </div>

                <div className="flex justify-between items-center py-2 border-b border-gray-100">
                  <span className="text-gray-600">Primary Tenant</span>
                  <span className="font-semibold text-gray-900">
                    {primaryTenant}
                  </span>
                </div>

                <div className="flex justify-between items-center py-2">
                  <span className="text-gray-600">
                    Date {isUpdate ? "Updated" : "Created"}
                  </span>
                  <span className="font-semibold text-gray-900 text-sm">
                    {formattedCreatedDate}
                  </span>
                </div>
              </div>
            </>
          )}
        </div>

        {/* Action Button */}
        <div className="px-6 pb-6">
          <CustomButton
            tailwindClasses={`w-full ${isModify ? "bg-orange-500 hover:bg-orange-600" : "bg-blue-500 hover:bg-blue-600"} text-white py-3 text-lg font-medium transition-colors`}
            label="View Details"
            onClick={onClose}
          />
        </div>
      </div>
    </div>
  );
};

export default CongratsModal;
